import { LogoFull } from "@/components/Logo";
import { SITE } from "@/constants/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#21262D] bg-[#0D1117] py-12">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div>
        <LogoFull />
        <p className="text-sm text-[#8B949E] mt-4 max-w-sm">{SITE.tagline}.</p>
      </div>
      <div className="font-mono text-xs text-[#8B949E] leading-loose sm:text-right">
        <p>{SITE.fullName}</p>
        <p>SIREN {SITE.siren} · {SITE.rcs}</p>
        <p>{SITE.address}</p>
        <a href="/admin/login" data-testid="footer-admin-link" className="inline-block mt-3 text-[#8B949E]/60 hover:text-[#F2541B] transition-colors">
          Espace admin →
        </a>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-10 pt-6 border-t border-[#21262D]">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8B949E]/50">
        © {new Date().getFullYear()} TPLM Guyane — Tous droits réservés
      </p>
    </div>
  </footer>
);
